export const GEO_TOKENS = ['3114f7aca360b9', 'e8726c78ee1b8b', '63ea99fe5e447d', '892f4e3e65b368'];
export const GEO_IP_URL = 'https://ipinfo.io/json';
